import {
  EGE_YEAR_OPTIONS,
  FINANCE_OPTIONS,
  GOAL_OPTIONS,
  SCORE_OPTIONS,
  needsEgeDetails,
} from '../questionnaire/options';

export const EMPTY_PARENT_QUESTIONNAIRE = {
  goal: '',
  goal_other: '',
  ege_year: '',
  ege_year_other: '',
  target_score: '',
  finance: '',
  attention_notes: '',
  messenger_url: '',
  phone: '',
  comment: '',
};

export const PARENT_GOAL_HINT =
  'Это ваш взгляд. Ученик заполняет свою анкету отдельно. Иногда цели не совпадают — так и пишите, как видите вы.';

export const PARENT_FINANCE_HINT =
  'Я не подгоняю цену часа к вашим возможностям (у меня фиксированная ставка). '
  + 'Предложу разные режимы работы. В любой момент можно переключиться.';

export const PARENT_ATTENTION_HINT =
  'Всё, что мне стоит знать как преподавателю: помягче или построже; можно ли не делать ДЗ; '
  + 'переживает ли, если не получается; как реагирует на ошибки; здоровье, нагрузка в школе, '
  + 'что лучше не трогать. Своими словами.';

export function parentQuestionnaireFromApi(data) {
  if (!data || typeof data !== 'object' || data.filled === false) {
    return {
      ...EMPTY_PARENT_QUESTIONNAIRE,
      phone: data?.phone || '',
    };
  }
  const next = { ...EMPTY_PARENT_QUESTIONNAIRE };
  Object.keys(EMPTY_PARENT_QUESTIONNAIRE).forEach((key) => {
    if (key === 'phone') {
      next.phone = data.phone || data.parent_phone || '';
    } else {
      next[key] = data[key] ?? '';
    }
  });
  return next;
}

export {
  EGE_YEAR_OPTIONS,
  FINANCE_OPTIONS,
  GOAL_OPTIONS,
  SCORE_OPTIONS,
  needsEgeDetails,
};
